import React from 'react';
import PropTypes from 'prop-types';
import { Request } from "sp-react-commons";
import Translation from "../../commons/i18n/Translation";
import { SearchApi } from "../api/Api";
import CustomSelect from "../../commons/components/CustomSelect";
import Svg from "../../../svg/Svg";

import {
    sortBy as _sortBy,
    take as _take,
    map as _map,
    flow as _flow,
} from 'lodash/fp';

const buildOption = (id, name, label, onSelect, permaLink, render) => ({id, name, label, onSelect, permaLink, render});

const MAX_RESULTS = 25; // Number of max results displayed in the input search

export default class MywortSearch extends React.Component {

    static propTypes = {
        selection : PropTypes.object,
        onChangeSelection : PropTypes.func,
        loadOptions: PropTypes.func
    };

    static defaultProps = {
        selection : null,
        onChangeSelection: () => {},
        loadOptions: () => {}
    };


    constructor(props){
        super(props);
        this.state = this.initialState(props);
    }

    initialState = () => ({
        localities: [],
        groups: []
    });

    transformOptions = (options, icon, onSelect) => {
        return _flow(
            _map( o => buildOption(o.id, o.name, o.label ? o.label : o.name, onSelect, o.permaLink, <div className="mywort-search-menu__option"><Svg id={icon} className="mywort-search-menu__option__svg"/>{ o.name }</div>) ),
            _sortBy( o => o.name ),
            _take(MAX_RESULTS)
        )(options);
    };

    transformLocalitiesOptions = (localities, input) => this.transformOptions(localities, "fa-location-arrow", this.onSelectLocality, input);
    transformGroupsOptions = (groups, input) => this.transformOptions(groups, "fa-users", this.onSelectGroup, input);

    getOptions = (input) => {
        let options = [];
        // Display a default option first to let user go to search page if he click on it
        if(input && input.length > 0) {
            options.push(buildOption(
                'localities-search-input-query',
                Translation.translate("search.for", {input: input}),
                input,
                this.onChangeSearch,
                "",
                <div className="mywort-search-menu__option"><Svg id="fa-file-text" className="mywort-search-menu__option__svg"/>{Translation.translate("search.for", {input: input})}</div>
            ));
        }

        return options
            .concat(this.state.localities)
            .concat(this.state.groups);
    };

    search = (input, cb) => {
        // Search for localities + groups, store results asap and display final results when everything has been loaded
        Request.all(
            () => SearchApi.searchLocality({ query: input }).then( (localities) => {
                this.setState({ localities: this.transformLocalitiesOptions(localities, input) });
            }),
            () => SearchApi.searchGroup({ query: input }).then( (groups) => {
                this.setState({ groups: this.transformGroupsOptions(groups, input) });
            })
       ).then( () => cb(this.getOptions(input)) );
    };

    loadOptions = (input, cb) => {
        if(input && input.length !== 0) {
            this.search(input, cb);
        } else {
            cb(null);
        }
    };

    onSelectLocality = (locality) => window.location = locality.permaLink;
    onSelectGroup = (group) => window.location = group.permaLink;

    onChangeSearch = (option) => window.location = "/" + Translation.getLanguageName() + "/mywort/search#/?query=" + encodeURIComponent(option.label);
    onChangeSelection = (option) => option ? option.onSelect(option) : null;

    render = () => (
        <MywortSearchPresenter
            selection={this.state.selection}
            onChangeSelection={this.onChangeSelection}
            loadOptions={this.loadOptions}
        />
    );
}


class MywortSearchPresenter extends React.Component {

    constructor(props){
        super(props);
    }

    componentDidMount = () => {
        // Create event to mount event listeners on touch and scroll, search.js
        var event = document.createEvent('Event');
        event.initEvent('search-mount', true, true);
        window.dispatchEvent(event);
    };

    onFocus = (event) => {
        if( $(document).find( '.Select-option.is-focused' ).length > 0 ) {
            var itemHeight = $(".Select-option.is-focused").height();
            var middle = $(".Select-menu-outer").height()  /2;
            if(event.keyCode === 40){
                $(".Select-menu-outer").scrollTop($(".Select-option.is-focused")[0].offsetTop - middle + itemHeight);
            } else {
                $(".Select-menu-outer").scrollTop($(".Select-option.is-focused")[0].offsetTop - middle);
            }
        }
    };

    render = () => (
        <CustomSelect
            async
            debounceTime={400}
            placeholder={Translation.translate("search.placeholder")}
            searchPromptText={Translation.translate("search.starttyping")}
            value={this.props.selection}
            onChange={this.props.onChangeSelection}
            loadOptions={(input, asyncSelectCallback) => this.props.loadOptions(input, asyncSelectCallback)}
            valueKey="id"
            labelKey="label"
            minimumInput={2}
            openOnFocus={true}
            optionRenderer={(option) => option.render}
            scrollMenuIntoView={false}
            ignoreAccents={false}
            arrowRenderer={() => null}
            onInputKeyDown={this.onFocus}
            cache={false}
            autoBlur={true}
        />
    );
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/components/MywortSearch.jsx